import React, { useState, useEffect } from "react";
import {
  Modal,
  Radio,
  Checkbox,
  Button,
  Typography,
  Divider,
  Input,
  Image,
} from "antd";
import repeatIcon from "../../Assets/calender/info-repeat-outline.png";
import "./RepeatModal.css";

const { Title, Text } = Typography;

const repeatOptions = [
  { value: "daily", label: "Daily", defaultEnd: "1" },
  { value: "weekly", label: "Every week", defaultEnd: "2" },
  { value: "monthly", label: "Every month", defaultEnd: "3" },
  { value: "yearly", label: "Every year", defaultEnd: "5" },
];

const allWeekendOptions = [
  { id: 2, label: "saturday" },
  { id: 3, label: "sunday" },
];

const RepeatModal = ({ visible, onCancel, onSave, initialValues, repeatOption,adjustWeeknd,startDate}) => {

  // console.log("repeatOption:::::::;",adjustWeeknd)
  const [repeatType, setRepeatType] = useState("none");
  const [endType, setEndType] = useState("after");
  const [occurrences, setOccurrences] = useState(1);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [excludeWeekends, setExcludeWeekends] = useState([]);
  const [adjustWeekends, setAdjustWeekends] = useState(false);

  useEffect(() => {
    if (!visible) return;

    const repeatTypeValue = initialValues?.repeatType?.value || "none";
    const selected = repeatOption.find((opt) => opt.value === repeatTypeValue);
    const defaultOccurrences = parseInt(selected?.defaultEnd) || 1;

    setRepeatType(repeatTypeValue);
    const newEndType = initialValues?.endType || "after";
    setEndType(newEndType);

    if (newEndType === "after") {
      setOccurrences(initialValues?.occurrences ?? defaultOccurrences);
      setCustomEndDate(null);
    } else {
      setCustomEndDate(
        initialValues?.customEndDate
          ? new Date(initialValues.customEndDate)
          : null
      );
    }
    // console.log("initialValues::",initialValues)
    setExcludeWeekends(
      Array.isArray(initialValues?.excludeWeekends)
        ? initialValues.excludeWeekends
        : []
    );

    setAdjustWeekends(!!initialValues?.adjustWeekends);
  }, [visible, initialValues]);

  useEffect(() => {
    if (endType === "after") {
      const selected = repeatOption && repeatOption?.find((opt) => opt.value === repeatType);
      const defaultYears = parseInt(selected?.defaultEnd) || 1;
      setOccurrences(defaultYears);
    }
  }, [repeatType, endType]);

  const handleRepeatChange = (e) => setRepeatType(e.target.value);
  const handleEndTypeChange = (e) => setEndType(e.target.value);
  const handleOccurrencesChange = (e) => setOccurrences(e.target.value);

  const toggleWeekend = (label) => {
    setExcludeWeekends((prev) =>
      prev.find((w) => w.label === label)
        ? prev.filter((w) => w.label !== label)
        : [...prev, allWeekendOptions.find((w) => w.label === label)]
    );
  };

  const getAdjustWeekendLabel = () => {
    const hasSaturday = excludeWeekends.find((w) => w.label === "saturday");
    const hasSunday = excludeWeekends.find((w) => w.label === "sunday");

    if (hasSaturday && hasSunday) return "Skip Weekends (Move to Previous Friday)";
    if (hasSaturday && !hasSunday) return "Skip Weekends (Move to Previous Friday)";
    if (!hasSaturday && hasSunday) return "Skip Weekends (Move to Previous Saturday)";
    return "Skip Weekends";
  };

  const handleSave = () => {
    onSave({
      repeatType: repeatOption.find((opt) => opt.value === repeatType),
      endType,
      occurrences,
      customEndDate: customEndDate ? customEndDate.toISOString() : null,
      excludeWeekends,
      adjustWeekends,
    });
  };

  const today = new Date();
  const maxDate = new Date();
  maxDate.setFullYear(today.getFullYear() + 50);

  return (
    <Modal
      title={
        <Title level={4}>
          <Image
            src={repeatIcon}
            style={{ maxWidth: 22, marginRight: 10 }}
            preview={false}
          />
          Repeat
        </Title>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={480}
    >
      <Radio.Group
        onChange={handleRepeatChange}
        value={repeatType}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}
      >
        {/* <Radio key="none" value="none">
          No repeat
        </Radio> */}
        {repeatOption && repeatOption.length && repeatOption.map((opt) => (
          <Radio key={opt.value} value={opt.value}>
            {opt.label_name}
          </Radio>
        ))}
      </Radio.Group>

      <Divider />
      {repeatType !== "none" && (
        <>
      <Text strong>⏳ End Repeat:</Text>
      <Radio.Group
        onChange={handleEndTypeChange}
        value={endType}
        style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}
      >
        <Radio value="after">
          After {occurrences} {occurrences === 1 ? "year" : "years"}
        </Radio>
        <Radio value="custom">Customize...</Radio>
      </Radio.Group>

      {endType === "custom" && (
        <div style={{ marginLeft: 24, marginTop: 8 }}>
          <Input
            type="date"
            value={customEndDate ? customEndDate.toISOString().split("T")[0] : ""}
            onChange={(e) => {
              const dateStr = e.target.value;
              setCustomEndDate(dateStr ? new Date(dateStr) : null);
            }}
            min={today.toISOString().split("T")[0]}
            max={maxDate.toISOString().split("T")[0]}
          />
        </div>
      )}

      <Divider />
      {(repeatType == 'monthly' || repeatType == 'yearly') &&
      <>
      <Text strong>🚫 Exclude Weekends:</Text>
      <div className="repeatWeekends" style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 4 }}>
        {allWeekendOptions.map((day) => (
          <Checkbox
            key={day.id}
            checked={!!excludeWeekends.find((w) => w.label === day.label)}
            onChange={() => toggleWeekend(day.label)}
          >
            Skip {day.label.charAt(0).toUpperCase() + day.label.slice(1)}s
          </Checkbox>
        ))}
      </div>
      </>
    }

      {excludeWeekends.some((w) => w.label === "saturday" || w.label === "sunday") && (
        <>
          <Divider />
          <Text strong>📅 Adjust for Weekends:</Text>
          <div className="repeatWeekends" style={{ marginTop: 8 }}>
            <Checkbox
              checked={adjustWeekends}
              onChange={(e) => setAdjustWeekends(e.target.checked)}
            >
              {getAdjustWeekendLabel()}
            </Checkbox>
          </div>
        </>
      )}

      <div style={{ textAlign: "right", marginTop: 32 }}>
        <Button onClick={onCancel} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </div>
      </>
      )}
    </Modal>
  );
};

export default RepeatModal;